






import Class from './c-content-chart-tone-bar';
export default Class;
